// src/components/button/NewsSortSelector.tsx

import { ExpandLessTwoTone, ExpandMoreTwoTone } from '@mui/icons-material'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { MouseEvent } from 'react'

import { ASC, DESC } from '../../api'

type Props = {
  data?: { label: string; value: string }[]
  onChange: (_event: MouseEvent<HTMLElement>, newValue: string) => void
  order: string
  orderby: string
}

export const NewsSortSelector = ({
  data = [
    { label: 'Titel', value: 'title' },
    { label: 'ID', value: 'entity_id' },
  ],
  onChange,
  order,
  orderby,
}: Props) => (
  <ToggleButtonGroup exclusive onChange={onChange} value={orderby}>
    {data.map(item => (
      <ToggleButton key={item.value} value={item.value}>
        {item.label}
        {item.value === orderby && order === ASC && <ExpandLessTwoTone />}
        {item.value === orderby && order === DESC && <ExpandMoreTwoTone />}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
)
